document.querySelectorAll('.ji-tcg').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const select = root.querySelector('[data-tcg-expansion]');
  const expansionParam = 'filter.p.m.custom.tcg_set';
  const requestedExpansion = new URLSearchParams(location.search).get(expansionParam);
  const requestedOption = select && Array.from(select.options).find(option => option.value === requestedExpansion);
  if (requestedOption) {
    select.value = requestedExpansion;
    const filters = root.querySelector('form.jt-filters');
    if (filters && !filters.elements.namedItem(expansionParam)) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = expansionParam;
      input.value = requestedExpansion;
      filters.append(input);
    }
    if (!root.querySelector('.jt-active-expansion')) {
      const chip = document.createElement('p');
      chip.className = 'jt-active-expansion';
      const remove = document.createElement('a');
      const reset = new URL(location.href);
      reset.searchParams.delete(expansionParam);
      reset.searchParams.delete('page');
      reset.searchParams.delete('tcg_page');
      remove.href = reset.href;
      remove.setAttribute('aria-label', 'Remove expansion filter');
      remove.textContent = 'Extension: ' + requestedOption.textContent.trim() + ' ';
      const close = document.createElement('span');
      close.setAttribute('aria-hidden', 'true');
      close.textContent = '×';
      remove.append(close);
      chip.append(remove);
      select.closest('.jt-navigation').after(chip);
    }
  }
  const go = root.querySelector('[data-tcg-go]');
  if (select && go) go.addEventListener('click', () => {
    const destination = new URL(select.selectedOptions[0]?.dataset.base || select.dataset.base, location.origin);
    if (select.value) destination.searchParams.set('filter.p.m.custom.tcg_set', select.value);
    const current = new URLSearchParams(location.search);
    const keep = new Set(['filter.v.availability', 'filter.p.product_type', 'filter.p.m.custom.tcg_rarity_ref', 'filter.p.m.custom.tcg_rarity_refs', 'filter.p.m.custom.tcg_card_kind_ref', 'sort_by']);
    for (const [key, value] of current) {
      if (keep.has(key)) destination.searchParams.append(key, value);
    }
    const preview = window.Shopify?.theme?.role === 'unpublished' ? window.Shopify.theme.id : current.get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    if ([...destination.searchParams.keys()].some(key => destination.searchParams.getAll(key).length > 1)) destination.searchParams.delete('preview_theme_id');
    location.assign(destination.href);
  });

  const directory = root.querySelector('[data-tcg-directory]');
  const load = directory?.querySelector('[data-tcg-load]');
  const status = directory?.querySelector('[data-tcg-load-status]');
  if (!select || !directory || !load || !status) return;
  load.addEventListener('click', async () => {
    if (load.disabled) return;
    load.disabled = true;
    directory.setAttribute('aria-busy', 'true');
    status.textContent = 'Loading expansions…';
    const selected = select.value;
    const options = new Map();
    const visited = new Set();
    const preview = window.Shopify?.theme?.role === 'unpublished' ? window.Shopify.theme.id : new URLSearchParams(location.search).get('preview_theme_id');
    let next = new URL(directory.dataset.indexUrl, location.origin);
    try {
      while (next) {
        if (next.origin !== location.origin) throw new Error('Unexpected directory origin');
        next.searchParams.set('section_id', 'ji-tcg-extension-options');
        if (preview) next.searchParams.set('preview_theme_id', preview);
        if (visited.has(next.href)) throw new Error('Repeated directory page');
        visited.add(next.href);
        const response = await fetch(next.href, {credentials:'same-origin', signal:AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Directory unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const index = html.querySelector('[data-tcg-index]');
        if (!index || index.dataset.game !== directory.dataset.game) throw new Error('Wrong game directory');
        index.querySelectorAll('[data-tcg-index-options] option').forEach(option => {
          if (option.value.startsWith('gid://shopify/Metaobject/')) options.set(option.value, {label:option.textContent.trim(),globo:option.dataset.globoValue || '',game:option.dataset.game || option.parentElement?.label || ''});
        });
        const link = index.querySelector('[data-tcg-index-next]');
        next = link ? new URL(link.getAttribute('href'), next) : null;
      }
      if (!options.size) throw new Error('Empty directory');
      const chosen = Array.from(select.options).find(option => option.value === selected);
      if (selected && !options.has(selected) && chosen) options.set(selected, {label:chosen.textContent,globo:chosen.dataset.globoValue || '',game:chosen.parentElement?.label || ''});
      const fragment = document.createDocumentFragment();
      fragment.append(select.options[0].cloneNode(true));
      const groups = new Map();
      if (directory.dataset.game === 'Dragon Ball') {
        ['Dragon Ball Fusion World','Dragon Ball Super Divers','Dragon Ball Cardass','Super Dragon Ball Heroes'].forEach(game => {
          const group=document.createElement('optgroup');group.label=game.replace('Cardass','Carddass');
          const existing=Array.from(select.querySelectorAll('optgroup')).find(item=>item.label===group.label);
          const all=existing?.querySelector('option[value=""][data-base]');
          if(all) group.append(all.cloneNode(true));
          group.dataset.base=existing?.querySelector('option[data-base]')?.dataset.base || select.dataset.base;
          groups.set(game,group);fragment.append(group);
        });
      }
      Array.from(options).sort((a,b)=>a[1].label.localeCompare(b[1].label,undefined,{numeric:true})).forEach(([value,entry]) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = entry.label;
        option.dataset.globoValue = entry.globo;
        option.dataset.base = groups.get(entry.game)?.dataset.base || select.dataset.base;
        (groups.get(entry.game) || fragment).append(option);
      });
      select.replaceChildren(fragment);
      select.value = selected;
      load.hidden = true;
      status.textContent = 'All expansions are available.';
      select.focus();
    } catch (error) {
      status.textContent = 'Could not load all expansions. Please try again.';
      load.disabled = false;
    } finally {
      directory.removeAttribute('aria-busy');
    }
  });
});


